import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-reset.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const ResetIcon = createSvgIcon(<Icon />, 'ResetIcon');
